import styled from "styled-components";
import { Heading, Button, SecondaryMenu } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const NoContentStyled = styled.div`
  position: relative;
  margin-bottom: ${props => props.theme.spacing.medium};
  ${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.baseLayoutPaddingBs}%;
  margin-${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  `calc(${props.theme.components.carousel.slideMargin.default} * 5)`};
`;

export const HeadingStyled = styled(Heading)`
  position: relative;
  margin-top: ${props => props.theme.baseLayoutPaddingBs}%;
  margin-${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  `calc(${props.theme.components.carousel.slideMargin.default} * 5)`};
  margin-bottom: ${props => props.theme.spacing.large};
`;

export const HeadingNoContentStyled = styled(Heading)`
  &&& {
    margin-bottom: ${props => props.theme.spacing.small};
    font-size: ${props => props.theme.font.size.small};
    text-transform: uppercase;
  }
`;

export const ButtonStyled = styled(Button)`
  margin-top: ${props => props.theme.spacing.small};
  & + & {
    margin-${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.spacing.small};
  }
`;

export const HeadingWrapper = styled.div`
  position: relative;
  ${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.baseLayoutPaddingBs}%;
  display: flex;
  align-items: center;
  h1 {
    margin-${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: ${props =>
  props.theme.spacing.xlarge};
  }
`;

export const SecondaryMenuStyled = styled(SecondaryMenu)`
  width: 40vw;
  margin-top: ${props => props.theme.spacing.medium};
  margin-${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.spacing.xlarge};
`;
